import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shown for any address that matches no route.
 *
 * WHY THIS EXISTS: the catch-all used to be
 *   <Route path="*" element={<Navigate to="/login" replace />} />
 * so a wrong or dead URL silently became the sign-in page. This app is the
 * cautionary tale: the booking-manager invite emailed a link to /viewer-register
 * after that page was deleted, and every recipient landed on a login screen that
 * looked entirely normal. The button reported success, the email sent, and the
 * fault went unreported for a week because nothing ever looked like a fault.
 *
 * The address that failed is shown deliberately. It is the single most useful
 * piece of information for whoever is working out what went wrong.
 */
export default function NotFoundPage() {
  const attempted = window.location.pathname + window.location.search;

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '2rem', background: '#f9fafb',
    }}>
      <div style={{
        maxWidth: '520px', width: '100%', textAlign: 'center',
        background: '#fff', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '2.5rem 2rem',
      }}>
        <div style={{ fontSize: '2.5rem', lineHeight: 1, marginBottom: '0.75rem' }}>🔍</div>

        <h1 style={{ fontSize: '1.4rem', fontWeight: 700, color: '#1a1a2e', margin: '0 0 0.6rem' }}>
          Page not found
        </h1>

        <p style={{ color: '#6b7280', fontSize: '0.95rem', margin: '0 0 1.25rem', lineHeight: 1.6 }}>
          There's nothing at this address. If you followed a link from an email,
          the link may be out of date &mdash; please let us know so we can fix it.
        </p>

        <div style={{
          background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '6px',
          padding: '0.6rem 0.8rem', marginBottom: '1.5rem',
          fontFamily: 'monospace', fontSize: '0.8rem', color: '#374151',
          wordBreak: 'break-all',
        }}>
          {attempted}
        </div>

        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => window.history.back()}
            style={{
              padding: '0.55rem 1.1rem', borderRadius: '7px', border: '1px solid #d1d5db',
              background: '#fff', color: '#374151', cursor: 'pointer', fontSize: '0.9rem', fontWeight: 500,
            }}
          >
            Go back
          </button>
          <Link
            to="/login"
            style={{
              padding: '0.55rem 1.1rem', borderRadius: '7px', border: 'none',
              background: '#1a1a2e', color: '#fff', textDecoration: 'none',
              fontSize: '0.9rem', fontWeight: 500, display: 'inline-block',
            }}
          >
            Go to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
